import React from 'react'
import type { DataTableColumn, DataTableSelect } from './DataTables.d'

const MOBILE_CARD_FIELD = '__mobileCard'

type DataColumn = DataTableColumn | DataTableSelect

export type MobileRowCardProps = {
    rowData: Record<string, unknown>
    columns: DataColumn[]
}

/**
 * Renders a single row as a card for mobile: each column becomes a label + value row.
 * Used inside DataTable as a column body so we can show this instead of the table row on small screens.
 */
const MobileRowCard: React.FC<MobileRowCardProps> = ({ rowData, columns }) => {
    const dataColumns = columns.filter(
        (col): col is DataColumn =>
            'field' in col && col.field !== MOBILE_CARD_FIELD
    )

    return (
        <div className="datatable-mobile-card">
            {dataColumns.map((col) => {
                const field = col.field
                const header = col.header ?? field
                const value: unknown =
                    typeof col.body === 'function'
                        ? (col.body as (rowData: Record<string, unknown>) => unknown)(rowData)
                        : rowData[field]

                const displayValue: React.ReactNode =
                    value == null || value === ''
                        ? '—'
                        : typeof value === 'object' && React.isValidElement(value)
                          ? value
                          : String(value)

                return (
                    <div
                        key={field}
                        className="datatable-mobile-card__row"
                    >
                        <span className="datatable-mobile-card__label">
                            {header}
                        </span>
                        <span className="datatable-mobile-card__value">
                            {displayValue}
                        </span>
                    </div>
                )
            })}
        </div>
    )
}

export default MobileRowCard
export { MOBILE_CARD_FIELD }
